/**
 * 判断给定坐标下，鼠标顶层的 DOM 元素是否在指定容器内（层级判断，用于自定义光标等场景）。
 * 会校验坐标合法性，避免 elementFromPoint 收到非有限值报错。
 *
 * @param pageX - 鼠标 pageX（或可换算为视口坐标的 x）
 * @param pageY - 鼠标 pageY（或可换算为视口坐标的 y）
 * @param container - 容器元素或容器 id
 * @returns 顶层元素在容器内为 true，否则 false（含 SSR/非法坐标）
 */
export function isPointerOverContainer(
  pageX: number,
  pageY: number,
  container: HTMLElement | string,
): boolean {
  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return false;
  }
  const scrollX = window.scrollX ?? window.pageXOffset ?? 0;
  const scrollY = window.scrollY ?? window.pageYOffset ?? 0;
  const clientX = pageX - scrollX;
  const clientY = pageY - scrollY;
  if (!Number.isFinite(clientX) || !Number.isFinite(clientY)) {
    return false;
  }
  const el =
    typeof container === 'string'
      ? document.getElementById(container)
      : container;
  if (!el) {
    return false;
  }
  const topmost = document.elementFromPoint(clientX, clientY);
  return topmost != null && el.contains(topmost);
}
